class MainPromotions extends HTMLElement {
  constructor() {
    super();

    const tabs = Array.from(this.querySelectorAll('.main-promotions__tab'));
    const items = Array.from(this.querySelectorAll('.main-promotions__item'));

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const filter = tab.getAttribute('data-filter');
  
        // Update active tab
        tabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        
        // Filter items
        items.forEach(item => {
          const category = item.getAttribute('data-category');
          
          if (filter === 'all') {
            item.classList.remove('hidden');
          } else if (category && category.includes(filter)) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      });
    });
  }
}

customElements.define('main-promotions', MainPromotions); 